import styled from 'styled-components';

export const LogoutButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  height: 30px;
`;

export const StyledLogoutButton = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin: 0 10px;
  color: ${({ theme }) => theme.palette.primaryBrand};
  transition: opacity 0.3s ease;

  & > strong {
    font-weight: bold;
  }

  &:hover {
    opacity: 0.75;
  }
`;

export const TotalMileAmountWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 10px;
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.black};
  width: 100%;
  padding: 8px 15px;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;

  transition: color 0.3s ease;
  &:hover {
    color: ${({ theme }) => theme.palette.lightBlack};
    background-color: ${({ theme }) => theme.palette.lightGray};
  }
`;

export const MenuItem = styled.div`
  height: 30px;
  display: inline-block;
  position: relative;

  display: flex;
  align-items: center;

  &:hover {
    .nav__submenu {
      display: block;
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const SubMenu = styled.ul`
  padding: 5px 0;
  font-weight: 300;
  text-transform: none;
  display: none;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 30px;
  width: 230px;
  z-index: 1;
  background-color: white;
  box-shadow: 0 0 2px 2px #0000004d;
  border-radius: 5px;

  transition: visibility 0.5s, opacity 0.5s linear;

  &:before {
    content: ' ';
    position: absolute;
    top: -5px;
    left: 30px;
    z-index: 2;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid white;
  }
`;

export const SubMenuItem = styled.li<{ index?: number }>`
  margin-bottom: 1px;
  border-bottom: 1px solid #0000001a;

  &:last-child {
    border-bottom: none;
  }
`;
